// Catálogo canónico de "Origen" de prospectos/oportunidades.
// Usado por Ventas y por el modal "Nuevo prospecto desde Cerebro".
// El backend valida el mismo conjunto en OrigenProspecto (models.py).

export const ORIGEN_OPTIONS = [
  { value: 'Meta (Facebook/Instagram)', label: 'Meta (Facebook/Instagram)' },
  { value: 'Google Ads', label: 'Google Ads' },
  { value: 'Referido', label: 'Referido' },
  { value: 'Nuevo Servicio', label: 'Nuevo Servicio' },
  { value: 'Nuevo Cliente', label: 'Nuevo Cliente' },
];

export const ORIGEN_VALUES = ORIGEN_OPTIONS.map((o) => o.value);
